<template>
  <nav class="myhome-footer" :class="user.targetCss.bgClass" aria-label="menu inferiore">
    <BottomBarButton
      v-if="user.authenticated"
      route-name="home"
      label="Home"
      :accent-class="user.targetCss.borderMod"
      :logo-class="`dea-aplogo-fill-${user.targetCss.colorMod}`"
      :icon-svg="baseApLogo"
    />
    <BottomBarButton
      v-if="user.authenticated && !user.principal && !user.generic"
      :loading="!loaded"
      route-name="books"
      :label="user.parent ? 'Libri' : 'I miei libri'"
      :accent-class="user.targetCss.borderMod"
      icon="copia-cartacea"
      :notifications="messagesByType.myHomeBooksStripe.length"
    />
    <BottomBarButton
      v-if="user.authenticated && (user.teacher || user.principal || user.generic)"
      :disabled="!loaded"
      :loading="!loaded"
      route-name="events"
      :label="user.principal || user.generic ? 'Formazione' : 'I miei eventi formativi'"
      :accent-class="user.targetCss.borderMod"
      :icon-file="formazioneLogo"
    />
    <BottomBarButton
      v-if="user.authenticated"
      :disabled="!bookmarksAvailable"
      :loading="!bookmarksLoaded"
      :route-name="bookmarksRoute"
      label="I miei preferiti"
      :accent-class="user.targetCss.borderMod"
      icon="preferiti"
    />
    <BottomBarButton
      v-if="user.authenticated && user.principal"
      :loading="!loaded"
      route-name="books"
      label="I miei libri"
      :accent-class="user.targetCss.borderMod"
      icon="copia-cartacea"
    />
    <BottomBarButton
      v-if="user.authenticated && !user.can_impersonate_role"
      :loading="!loaded"
      route-name="my-profile-data"
      label="Il mio profilo"
      :accent-class="user.targetCss.borderMod"
      :icon-file="myProfileLogo"
      logo-class="myhome-footer__icon-image--user-logo"
    />
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

// eslint-disable-next-line import/no-webpack-loader-syntax
import baseApLogo from "!svg-inline-loader!@/assets/logo/dea/home-logo-light-grey.svg";
import formazioneLogo from "~/assets/Formazione_horizontal_2022.svg";
import myProfileLogo from "~/assets/my-profile-logo.svg";
import BottomBarButton from "~/components/shared/BottomBarButton";

export default {
  name: "BottomBar",
  components: { BottomBarButton },
  props: {
    user: {
      type: Object,
      required: true,
    },
    booksCount: {
      type: Number,
      default: 0,
    },
    eventsCount: {
      type: Number,
      default: 0,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    profileUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseApLogo,
      formazioneLogo,
      myProfileLogo,
    };
  },
  computed: {
    ...mapGetters(["bookmarksAvailable", "bookmarksLoaded", "messagesByType"]),
    bookmarksRoute() {
      return this.user.parent ? "bookmarks-dealive" : "bookmarks-resources";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_local-variables"; //sass-lint:disable-line clean-import-paths

@keyframes loadingAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: $opacity-disabled;
  }

  100% {
    opacity: 1;
  }
}

.myhome-footer {
  align-items: flex-end;
  bottom: 0;
  box-shadow: $bottom-bar-shadow;
  display: flex;
  height: $bottom-bar-height;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 5;

  &__content {
    font-family: $font-primary;
    padding: $space-m-small 0;
  }
}
</style>
